module.exports = __webpack_public_path__ + "static/img/Nathan-Cleary.6c4fd65.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Nathan-Cleary.jpg
// module id = VUsT
// module chunks = 0